<script>
import { Doughnut } from "vue-chartjs";

export default {
    data() {
        return {
            chart: {
                datasets: [
                    {
                        data: [0, 0],
                        backgroundColor: [
                            "rgba(61, 212, 155, 0.8)",
                            "rgba(249, 108, 126, 0.8)"
                        ]
                    }
                ],

                // These labels appear in the legend and in the tooltips when hovering different arcs
                labels: ["Satisfied", "Not Satisfied"]
            },
            options: {
                responsive: true,
                aspectRatio: 2.4,
                legend: {
                    position: "right"
                }
            }
        };
    },
    props: ["data", "labels"],
    extends: Doughnut,
    mounted() {},
    created() {},
    watch: {
        data: function(newValue, oldValue) {
            this.chart.datasets[0].data = newValue;
            this.renderChart(this.chart, this.options);
        },
        labels: function(newValue, oldValue) {
            this.chart.labels = newValue;
            this.renderChart(this.chart, this.options);
        }
    },
    methods: {}
};
</script>
